module.exports = __webpack_public_path__ + "static/media/doctor_online.c46c8ebe.png";